import { ArrowUpTrayIcon } from '@heroicons/react/20/solid';
import type { ReactNode } from 'react';
import { type Accept, type DropzoneOptions, useDropzone } from 'react-dropzone';
import { MAX_FILE_SIZE_BYTES } from '../hooks/use-invoice-upload';

type FileDropzoneProps = {
  accept: Accept;
  label: string;
  onDrop: NonNullable<DropzoneOptions['onDrop']>;
  multiple?: boolean;
  disabled?: boolean;
  children?: ReactNode;
};

export function FileDropzone({
  accept,
  label,
  onDrop,
  multiple = true,
  disabled = false,
  children,
}: FileDropzoneProps) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept,
    maxSize: MAX_FILE_SIZE_BYTES,
    multiple,
    useFsAccessApi: false,
    disabled,
    onDrop,
  });

  return (
    <div
      {...getRootProps()}
      className={`flex justify-center rounded-lg border border-dashed px-6 py-10 transition ${
        isDragActive
          ? 'border-primary-400 bg-primary-50'
          : 'border-gray-900/25 bg-white hover:border-gray-400'
      } ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <div className="text-center">
        <ArrowUpTrayIcon className="mx-auto h-12 w-12 text-gray-300" aria-hidden="true" />
        <div className="mt-4 flex text-sm leading-6 text-gray-600 justify-center">
          <span className="font-semibold text-primary-600">{label}</span>
          <p className="pl-1">or drag and drop</p>
          <input {...getInputProps()} disabled={disabled} />
        </div>
        {children}
      </div>
    </div>
  );
}
